import { Component, TemplateRef, ViewChild } from '@angular/core';
import { INgSelectTemplate } from '@shared/modules/form-components/select/classes/INgSelectTemplate';

@Component({
  selector: 'app-filter-label-template',
  templateUrl: './filter-label-template.component.html',
  styleUrls: ['./filter-label-template.component.scss'],
})
export class FilterLabelTemplateComponent implements INgSelectTemplate {
  @ViewChild(TemplateRef, { static: true, read: TemplateRef })
  templateRef: TemplateRef<HTMLElement>;
}
